/** Miroir côté navigateur de worker/src/lib/overlay.ts::getOverlayCardEntry —
 * gère les deux formes possibles d'un fichier de traduction Shoggoth (map
 * indexée par id, confirmée par un vrai fichier réel ; ou tableau, gardé par
 * robustesse). Purement synchrone : l'overlay est déjà en mémoire (voir le
 * cache de ProjectView), aucun appel réseau ici. */
export function getOverlayCardEntry(overlay: any, cardId: string): any | undefined {
  if (!overlay?.cards) return undefined;
  if (Array.isArray(overlay.cards)) {
    return overlay.cards.find((c: any) => c?.id === cardId);
  }
  return overlay.cards[cardId];
}
